import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

export const ConcentricCircles: FC<IconSVGComponentProps> = (props) => {
    return (
        <IconSVG viewBox="0 0 20 20" fill="none" {...props}>
            <circle cx="10.426" cy="9.9" r="8.25" stroke="currentColor" />
            <circle cx="10.427" cy="9.901" r="4.65" stroke="currentColor" />
        </IconSVG>
    );
};
